var _rect, _path;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgDashboardIcon3(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 66,
    height: 65,
    viewBox: "0 0 66 65",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 66,
    height: 65,
    rx: 10,
    fill: "#F6F8FF"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M44.5737 18C45.3391 18 45.9604 18.6272 45.9604 19.4V24.6598L33.4816 37.2598L33.4733 43.193L39.3611 43.2014L45.9604 36.5388V44.6C45.9604 45.3728 45.3391 46 44.5737 46H22.3867C21.6212 46 21 45.3728 21 44.6V19.4C21 18.6272 21.6212 18 22.3867 18H44.5737ZM47.0392 27.5312L49 29.5108L38.2143 40.4L36.2508 40.3972L36.2536 38.4204L47.0392 27.5312ZM33.4802 32H26.5468V34.8H33.4802V32ZM37.6403 26.4H26.5468V29.2H37.6403V26.4Z",
    fill: "#5F6FFF"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDashboardIcon3);
export default __webpack_public_path__ + "static/media/dashboard_icon_3.e899d37059e2ab8705302e4e8486a840.svg";
export { ForwardRef as ReactComponent };